export enum DesignRuntimeEngine {
  graalVm = 'GRAAL_VM',
  nashorn = 'NASHORN'
}
